import { render, staticRenderFns } from "./textelement.vue?vue&type=template&id=29fd5e67&scoped=true"
import script from "./textelement.vue?vue&type=script&lang=js"
export * from "./textelement.vue?vue&type=script&lang=js"
import style0 from "./textelement.vue?vue&type=style&index=0&id=29fd5e67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fd5e67",
  null
  
)

export default component.exports